import React, {Component} from 'react';
import {connect} from "react-redux";
import 'react-bootstrap';

import store from '../../../store/configureStore';
import { Businesses, PagesForCaption, CaptionCodes } from '../../../config/Helper';
import {changeActiveItemAction} from '../../../actions/navAction';
import {changeTopBannerAction} from '../../../actions/topBannerAction';
import captionApi from '../../../api/captionApi';
import SingleServiceBlock from './SingleServiceBlock';

class SingleService extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
            captionTitle : []
        }
        this.lang = props.language.lang_key;

        this.getCaptions = this.getCaptions.bind(this);
    }

    componentWillMount() { 
        this.getCaptions();
        store.dispatch(changeTopBannerAction({
            page        : '',
            showSearch  : false,
            isHome      : false}));
    }

    componentDidMount() {
        store.dispatch(changeActiveItemAction(Businesses.indexOf('destination')));
        window.onSetClass('dark');
        window.scrollTop('#root');
    }
  
    componentWillUnmount() {
        
    }
    
    componentWillReceiveProps(newProps) {
        if (this.lang !== newProps.language.lang_key) {
            this.lang = newProps.language.lang_key;
            this.getCaptions();
        }
    }   

    getCaptions() {
        captionApi.getCaptions('service_detail').then((json) => {        
            if (json.status === 200) {    
                this.setState({
                    captionTitle: json.data
                });
            } else {

            }            
        })
    }
  
    render() {

        return (
            <SingleServiceBlock
                serviceID              = {this.props.match.params.service_id}
                otherServiceTitle      = {this.state.captionTitle[CaptionCodes[PagesForCaption.indexOf('service_detail')].indexOf('service_other_services')] === undefined ?
                "" : this.state.captionTitle[CaptionCodes[PagesForCaption.indexOf('service_detail')].indexOf('service_other_services')].title}
                serviceExperienceTitle = {this.state.captionTitle[CaptionCodes[PagesForCaption.indexOf('service_detail')].indexOf('service_experience')] === undefined ?
                "" : this.state.captionTitle[CaptionCodes[PagesForCaption.indexOf('service_detail')].indexOf('service_experience')].title}
            />
        );
    }
}

function mapStateToProps(state) {
    return { 
        language: state.language
    };
}
export default connect(mapStateToProps)(SingleService);